import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { cflogo } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView w="100%" column center>
          <CFView
            w="100%"
            textLeft
            pb="40px"
            style={{
              boxSizing: 'border-box',
              paddingLeft: '25%',
            }}
          >
            <CFView
              style={{ fontSize: '12px' }}
              color="#666666"
              helvetica
              pb="5px"
            >
              © 2026 sushimoto.
            </CFView>

            <CFView
              style={{ fontSize: '12px' }}
              color="#666666"
              helvetica
              pb="5px"
            >
              designed exclusively for sushimoto
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView w="100%" column center maxWidth="1440px">
          <CFView w="100%" textLeft pb="40px" ml="85%">
            <CFView
              style={{ fontSize: '12px' }}
              color="#666666"
              helvetica
              pb="5px"
            >
              © 2026 sushimoto.
            </CFView>

            <CFView
              style={{ fontSize: '12px' }}
              color="#666666"
              helvetica
              pb="5px"
            >
              designed exclusively for sushimoto
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
